import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOptions = function () {
    return useApiCall(function (signal) { return api.option.apiOptionDataGet({ signal: signal }); }, [], true);
};
